module.exports = __webpack_public_path__ + "static/media/class_small_priest.74da5ea8.png";